/*
 * @Autor: 陈钊贤
 * @Version: 1.0
 * @Date: 2019-11-15 09:29:32
 * @LastEditors: 陈钊贤
 * @Description:
 * @LastEditTime: 2020-11-05 20:01:30
 */
import config from '@/config/config';
import pageLoading from '@/components/pi-loading/pi-loading';

function addJS(url, id) {
  pageLoading.open();
  return new Promise(async (resolve) => {
    var scriptObj = document.getElementById(id);
    if (scriptObj != null) {
      resolve();
      pageLoading.close();
    } else {
      var scriptDom = document.createElement('script');
      scriptDom.id = id;
      scriptDom.type = 'text/javascript';
      scriptDom.src = url;
      document.head.appendChild(scriptDom);
      scriptDom.onload = function () {
        resolve();
        pageLoading.close();
      };
    }
  });
}

export const MapJS = () => { // 高德地图
  let url = 'https://webapi.amap.com/maps?v=1.3&key=' + config.mapKey + '&plugin=AMap.MarkerClusterer,AMap.Driving,AMap.service,AMap.Geocoder,AMap.Autocomplete';
  // let url = 'http://webapi.amap.com/maps?v=1.3&key=&plugin=AMap.MarkerClusterer,AMap.Driving,AMap.service,AMap.Geocoder,AMap.Autocomplete';
  // let url = 'https://webapi.amap.com/maps?v=1.3&key=&plugin=AMap.MarkerClusterer,AMap.Driving,AMap.service';
  return addJS(url, 'scriptMap');
};

export const echartsJS = () => { // 图表
  let url = config.host + '/common/echarts.min.js';
  return addJS(url, 'echartsJS');
};
export const addQrcode = () => { // 二维码
  let url = config.host + '/common/qrcode.min.js';
  return addJS(url, 'qrcode-min');
};